import React from "react";

const GapRenderer = ({ value }) => {

    if (value === undefined || value === null) return null;

    const valueToUse = typeof value === "number" ? value : value?.value;

    return (
        <span style={{ color: valueToUse < 0 ? "var(--ownRed)" : "var(--mainText)", fontWeight: 500 }}>
            {valueToUse}
        </span>
    )

}

export default GapRenderer;